<header class="main-header">
    <mat-toolbar class="c-head">
        <div class="container">
            <div class="h-inner">
                <nav class="navbar navbar-expand-lg">
                    <div class="container-fluid">
                        <a class="navbar-brand logo" routerLink="/">
                            <img src="assets/images/logo.svg" alt="" />
                        </a>
                        <button class="navbar-toggler" type="button" (click)="toogleMenu()">
                            <span class="navbar-toggler-icon"></span>
                        </button>
                        <div class="collapse navbar-collapse" [class]="toogle?'show':''" id="navbarSupportedContent">
                            <ul class="navbar-nav m-list m-auto d-flex">
                                <li class="nav-item" (click)="toogleMenu()"><a class="nav-link"
                                        routerLink="/">{{Global.APP_NAME}}</a></li>
                                <li class="nav-item" (click)="toogleMenu()"><a class="nav-link"
                                        routerLinkActive="active-link" routerLink="/howitworks">How it Works</a></li>
                                <li class="nav-item" (click)="toogleMenu()"><a class="nav-link"
                                        routerLinkActive="active-link" routerLink="/about">About Us</a></li>
                                <li class="nav-item" (click)="toogleMenu()"><a class="nav-link"
                                        routerLinkActive="active-link" routerLink="/subscription">Subscription</a></li>
                                <li class="nav-item" (click)="toogleMenu()"><a class="nav-link"
                                        routerLinkActive="active-link" routerLink="/contact">Contact Us</a></li>
                            </ul>
                            <div class="h-right">
                                <ng-container *ngIf="authService.coachLoggedIn(); else authRedBlock">
                                    <a mat-button routerLink="/dashboard">Dashboard</a>
                                </ng-container>

                                <ng-template #authRedBlock>
                                    <a mat-button routerLink="/signup">Sign up</a>
                                    <a mat-button routerLink="/login">Login</a>
                                </ng-template>
                            </div>
                        </div>
                    </div>
                </nav>
            </div>
        </div>
    </mat-toolbar>
</header>